(function($) {
var oldPrice = window.comparePrice;
var basePrice = window.currentPrice / 100;

function waitForCPB() {
if($('.cpb-panels-container').length) {
initChanges();
} else {
requestAnimationFrame(waitForCPB);
}
}
waitForCPB();

function initChanges() {
changePriceSign();
}

function changePriceSign() {
var priceWrapper = $('.cpb-product-price');
var price = priceWrapper[0].querySelector('span');
price.innerText = price.innerText.replace(',', ' ');
var config = {
characterData: true,
subtree: true
}
var observer = new MutationObserver(function() {
price.innerText = price.innerText.replace(',', ' ');
}.bind(this));
observer.observe(price, config);
}

});

(function($) {
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init)
	
  function init() {
    featuredCards()    
    moveBottomSection.init()
  	moveReviewsBadge.init()
    moveProductActions.init()
    setCssVariables.init()
//     moveTrustIcons.init()
    fixedActions.init()
    trustIcons()
  }


  
  function trustIcons() {
  	const actions = $('.cpb-panels-container .cpb-product-actions')
    const iconsWrapper = $('<div class="cpb-custom-trust-icons-wrapper">')
    
    let categoryObj
    CPB.getStore().getState().Product.panels.forEach(function(panel) {
      if(categoryObj) return
      categoryObj = panel.categories.find(function(category) {
      	return category.extraClassName.includes('trust-icons--js')
      })
    })
    if(!categoryObj) return
    
    categoryObj.options.forEach(function(option) {
      const iconWrapper = $('<div class="cpb-custom-trust-icon">')
      const img = $('<img class="cpb-custom-trust-icon__img" src="' + option.option.data.value + '" alt="' +  option.option.data.label + '">')
      iconsWrapper.append(iconWrapper.append(img))
    })
    
    actions.after(iconsWrapper)
  }
  
  function featuredCards() {
  	const container = $('.cpb-custom-feature-cards-container').first()
    if(container.length === 0) return
    
    let categoryObj
    CPB.getStore().getState().Product.panels.forEach(function(panel) {
      if(categoryObj) return
      categoryObj = panel.categories.find(function(category) {
      	return category.extraClassName.includes('feature-cards--js')
      })
    })
    if(!categoryObj) return
    
    const wrapper = $('<div class="cpb-custom-feature-cards">')
    
    let i = 0
    categoryObj.options.forEach(function(option) {
      if(++i > 6) return
      const card = $('<div class="cpb-custom-feture-card">')
      const img = $('<img class="cpb-custom-feture-card__img" src="' + option.option.data.value + '" alt="' +  option.option.data.label + '">')
      const info = $('<div class="cpb-custom-feture-card__info">')
      const infoInner = $('<div>')
      infoInner.html('<h3>' + option.option.data.label + '</h3>' + option.optionDescription)
      card.append(img, info.append(infoInner))
      wrapper.append(card)
    })
 
    container.append(wrapper)
    
    ;(function() {
      const container = wrapper[0]
      const cards = container.querySelectorAll('.cpb-custom-feture-card')
      if(mobileCheck() === true) {
        container.classList.add('mobile')
      }

      cards.forEach(card => {
        const observer = new IntersectionObserver(([e]) => {
          if(e.intersectionRatio === 1) {
              e.target.classList.add('is-on-screen')
          } else {
              e.target.classList.add('moving-out-of-screen')
              e.target.classList.remove('is-on-screen')
              setTimeout(function() {
                e.target.classList.remove('moving-out-of-screen')
              }, 50)
          }

        }, {threshold: 1})
        observer.observe(card)
      })

      function mobileCheck() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      }
    })()
  }
  
  const fixedActions = {
    init() {
      const realAddToCart = $('.cpb-add-to-cart-button').eq(0)
      const addToCart = $('<button type="button" class="cpb-custom-add-to-cart-fixed">Buy now</button>')
      const toTopButton = $('<button type="button" class="cpb-custom-to-top-fixed">&#9651;</button>')
      
      addToCart.on('click', function() {
      	realAddToCart.trigger('click')
      })
      toTopButton.on('click', function() {
      	window.scrollTo({top: 0, behavior: 'smooth'})
      })
      
      $('#product-builder').append(addToCart, toTopButton)
    }
  }
  
  const moveTrustIcons = {
    init() {
      const trustIcons = $('.cpb-panel-description .cpb_trust-icons')
      const iconsWrapper = $('<div class="cpb-custom-trust-icons-wrapper">')
      const actions = $('.cpb-panels-container .cpb-product-actions')
      iconsWrapper.append(trustIcons)
      actions.after(iconsWrapper)
    }
  }
  
  const moveBottomSection = {
    init() {
      const panelsContainer = $('.cpb-panels-container')
      const bottomSection = $('.cpb-custom-bottom-section')
      panelsContainer.after(bottomSection.show())
    }
  }
  
  const setCssVariables = {
    builder: false,
    init() {
      this.builder = $('#product-builder')
      this.header()
    },
    header() {
      const that = this
      const headerEl = $('#shopify-section-header')
      this.setVariable('--header-height-js', headerEl.height() + 'px')
      const observer = new ResizeObserver(function() {
      	that.setVariable('--header-height-js', headerEl.height() + 'px')
      })
      observer.observe(headerEl[0])
    },
    setVariable(key, value) {
      let style = this.builder.attr('style') || ''
      if(style.includes(key)) {
        const regex = new RegExp(key + ':[^;]+;', 'i')
        style = style.replace(regex, '')
      }      
      style = style += key + ':' + value + ';'
      this.builder.attr('style', style)
    }
  }
  
  const moveProductActions = {
    init() {
      const panelContainer = $('.cpb-panels-container')
      const panelTabs = panelContainer.find('.cpb-panels-tabs')
      const productActions = panelContainer.find('.cpb-product-actions')
      panelTabs.append(productActions)
    }
  }
  
  const moveReviewsBadge = {
    init() {
      const panelsContainer = $('.cpb-panels-container')
      const panelTabs = panelsContainer.find('.cpb-panels-tabs')
      const badgeContainer = $('.judgeme-badge-container')
      const productTitle = panelsContainer.find('.cpb-product-title')
      if(productTitle.length > 0) productTitle.after(badgeContainer.show())
      else panelTabs.prepend(badgeContainer.show())
    }
  }
})(jQuery)